(function () {
  const SELECTOR = [
    '.bcd-img-wrap img',
    '.bcd-swatch img',
    '.product-main-image img',
    '.thumb-image img',
    '.cart-item__image'
  ].join(', ');

  // Product grids and search already remove white visually with mix-blend-mode.
  // Keep those images on Shopify's responsive CDN instead of replacing their
  // srcset with a viewport-sized canvas PNG, which becomes blurry on high-DPR
  // screens and blocks mobile scrolling while pixels are processed.

  const WHITE_THRESHOLD = 245;
  const SATURATION_THRESHOLD = 18;

  function isNearWhite(data, index) {
    const red = data[index];
    const green = data[index + 1];
    const blue = data[index + 2];
    const alpha = data[index + 3];

    if (alpha < 16) return false;

    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);

    return max >= WHITE_THRESHOLD && min >= WHITE_THRESHOLD - 10 && max - min <= SATURATION_THRESHOLD;
  }

  function buildEdgeMask(imageData, width, height) {
    const { data } = imageData;
    const visited = new Uint8Array(width * height);
    const queue = [];
    let head = 0;

    function enqueueIfWhite(x, y) {
      const pixelIndex = y * width + x;
      if (visited[pixelIndex]) return;
      const dataIndex = pixelIndex * 4;
      if (!isNearWhite(data, dataIndex)) return;
      visited[pixelIndex] = 1;
      queue.push(pixelIndex);
    }

    for (let x = 0; x < width; x += 1) {
      enqueueIfWhite(x, 0);
      enqueueIfWhite(x, height - 1);
    }

    for (let y = 0; y < height; y += 1) {
      enqueueIfWhite(0, y);
      enqueueIfWhite(width - 1, y);
    }

    while (head < queue.length) {
      const pixelIndex = queue[head++];
      const x = pixelIndex % width;
      const y = Math.floor(pixelIndex / width);

      if (x > 0) enqueueIfWhite(x - 1, y);
      if (x + 1 < width) enqueueIfWhite(x + 1, y);
      if (y > 0) enqueueIfWhite(x, y - 1);
      if (y + 1 < height) enqueueIfWhite(x, y + 1);
    }

    return visited;
  }

  function hasWhiteBorder(imageData, width, height) {
    const { data } = imageData;
    let whiteSamples = 0;
    let totalSamples = 0;

    for (let x = 0; x < width; x += 1) {
      totalSamples += 2;
      if (isNearWhite(data, x * 4)) whiteSamples += 1;
      if (isNearWhite(data, ((height - 1) * width + x) * 4)) whiteSamples += 1;
    }

    for (let y = 1; y < height - 1; y += 1) {
      totalSamples += 2;
      if (isNearWhite(data, (y * width) * 4)) whiteSamples += 1;
      if (isNearWhite(data, (y * width + (width - 1)) * 4)) whiteSamples += 1;
    }

    return totalSamples > 0 && whiteSamples / totalSamples > 0.45;
  }

  function processImage(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.dataset.whiteBgProcessed === 'true') return;
    if (!img.complete || !img.naturalWidth || !img.naturalHeight) return;

    img.dataset.whiteBgProcessed = 'true';

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', { willReadFrequently: true });

    if (!context) return;

    const maxDimension = 1400;
    const scale = Math.min(1, maxDimension / Math.max(img.naturalWidth, img.naturalHeight));
    const width = Math.max(1, Math.round(img.naturalWidth * scale));
    const height = Math.max(1, Math.round(img.naturalHeight * scale));

    canvas.width = width;
    canvas.height = height;

    try {
      context.drawImage(img, 0, 0, width, height);
      const imageData = context.getImageData(0, 0, width, height);

      if (!hasWhiteBorder(imageData, width, height)) return;

      const mask = buildEdgeMask(imageData, width, height);
      let changed = false;

      for (let pixelIndex = 0; pixelIndex < mask.length; pixelIndex += 1) {
        if (!mask[pixelIndex]) continue;
        imageData.data[pixelIndex * 4 + 3] = 0;
        changed = true;
      }

      if (!changed) return;

      context.putImageData(imageData, 0, 0);
      img.src = canvas.toDataURL('image/png');
      img.srcset = '';
      img.sizes = '';
    } catch (error) {
      img.dataset.whiteBgProcessed = 'error';
    }
  }

  function watchImage(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.complete) {
      processImage(img);
      return;
    }

    img.addEventListener('load', function onLoad() {
      img.removeEventListener('load', onLoad);
      processImage(img);
    }, { once: true });
  }

  function scan(root) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(watchImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      document.removeEventListener('DOMContentLoaded', onReady);
      scan(document);
    });
  } else {
    scan(document);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(SELECTOR)) watchImage(node);
        scan(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
